"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    LocationPinSolid: function() {
        return LocationPinSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const LocationPinSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M12 1C7.02944 1 3 5.02944 3 10C3 12.5262 4.14683 14.7402 5.70772 16.767C7.01205 18.4607 8.68193 20.1161 10.3496 21.7693C10.6648 22.0817 10.9804 22.3946 11.2929 22.7071C11.6834 23.0976 12.3166 23.0976 12.7071 22.7071C13.0198 22.3944 13.335 22.0819 13.6503 21.7694C15.318 20.1161 16.988 18.4607 18.2923 16.767C19.8532 14.7402 21 12.5262 21 10C21 5.02944 16.9706 1 12 1ZM15 10C15 11.6569 13.6569 13 12 13C10.3431 13 9 11.6569 9 10C9 8.34315 10.3431 7 12 7C13.6569 7 15 8.34315 15 10Z",
        fill: "currentColor"
    })
}), "LocationPinSolid");
const _default = LocationPinSolid;
